import { loadFont } from "helpers";
import { useEffect } from "react";

export function useLoadFont(fontLink: string) {
  useEffect(() => {
    loadFont(fontLink);
  }, []);
}
